export const contentTableConfig = {
  title: '直播间留存统计列表',
  propList: [
    {prop: 'channelName', label: '直播间', minWidth: '80'},
    {prop: 'timeLong', label: '观看时长（分钟）', minWidth: '80'},
    {prop: 'timeSlot', label: '统计时间段', minWidth: '80'},
    {prop: 'statisticsNum', label: '统计量', minWidth: '80', sortable: 'custom'},
    {prop: 'totalNum', label: '观看总量', minWidth: '80', sortable: 'custom'},
    {prop: 'retainedRate', label: '观看留存率', minWidth: '80'},
    {label: '操作', minWidth: '60', slotName: 'handler'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
